import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateNotification, Notification, NotificationListResponse, NotificationQueryParams } from '@frontend/notification/types';

export class NotificationClient extends APIClient {
    public static readonly endpoint = '/notification-api/v1';

    public static async fetchNotifications(queryParams?: ApiQueryParams<NotificationQueryParams>): Promise<NotificationListResponse> {
        return await this.apiPaginated<NotificationListResponse, NotificationQueryParams>(`${this.endpoint}/notifications`, queryParams);
    }

    public static async resolveNotifications(ids: string[], field: string = 'id'): Promise<NotificationListResponse> {
        return this.resolve<NotificationListResponse>(`${this.endpoint}/notifications`, ids, field);
    }

    public static async deleteNotifications(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/notifications-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postNotification(accountId: string, body: CreateNotification): Promise<Notification> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/notifications`, body);
        return await this.handleResponse<Notification>(response);
    }

    public static async fetchAccountNotification(accountId: string, notificationId: string): Promise<Notification> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/notifications/${notificationId}`);
        return await this.handleResponse<Notification>(response);
    }

    public static async deleteNotification(accountId: string, notificationId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/notifications/${notificationId}`);
        return await this.handleVoidResponse(response);
    }

    public static async fetchMyNotifications(queryParams?: ApiQueryParams<NotificationQueryParams>): Promise<NotificationListResponse> {
        return await this.apiPaginated<NotificationListResponse, NotificationQueryParams>(`${this.endpoint}/my-notifications`, queryParams);
    }
}
